import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from '../images/stlog-logo.svg';
import Footer_text from '../images/footer_text.png'; 
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay-ts';

import { useUserAuth } from "../context/UserAuthContext";

import axios from 'axios';

function Login(props) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingMsg, setLoadingMsg] = useState("Logging In ...");

    const [modalBody, setModalBody] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState("");

    const [disableLoginBtn, setDisableLoginBtn] = useState(true);

    const handleClose = () => setShowModal(false);

    const { logIn } = useUserAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (email != "" && password != "") {
            setDisableLoginBtn(false);
        }
        else {
            setDisableLoginBtn(true);
        }

    }, [email, password])

    function handleKeypress(e) {
        //it triggers by pressing the enter 
        console.log(e)
        if (e.keyCode === 13) {
            processLogin(e);
        }
    };

    async function processLogin(e) {
        //e.preventDefault();

        try {
            let login_info
            setLoadingActive(true);
            login_info = await logIn(email, password);

            console.log(login_info);

            let user = {};
            user.accessToken = login_info.user.accessToken
            user.email = login_info.user.email
            user.uid = login_info.user.uid

            let url = process.env.REACT_APP_API_SERVER + "/login";

            axios.post(url, {
                "email": login_info.user.email,
                "accessToken": login_info.user.accessToken,
                "uid": login_info.user.uid
            })
                .then(function (response) {
                    localStorage.setItem('user', JSON.stringify(user));
                    navigate("/Overview");
                })
                .catch(function (error) {
                    console.log(error);
                    setLoadingActive(false);

                });
        }
        catch (err) {
            setModalHeader("Unable to Login")
            let err_msg = ""
            if (err.message == "Firebase: Error (auth/internal-error)." || err.message == "Firebase: Error (auth/wrong-password).") {
                err_msg = "Your email or password is incorrect."
            } else {
                err_msg = err.message
            }
            setModalBody(err_msg);
            setShowModal(true);
            setLoadingActive(false);
        }

    }

    return (
        <div align="center" style={{ width: "100%", height: "100vh" }}>

            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingMsg}
                className="spinner_div"
            >

                <div align="center" style={{backgroundColor: "#007A68", width:"100%", height:"50px", paddingTop:"12px"}}>
                    <img style={{ width: "180px" }} src={Logo} alt='stlog-logo'></img>
                </div>

                <div align="center" style={{ width: "100%" }}>
                    <div style={{ height: "30px" }}></div>

                    <div className="login_text_1">Bin Sensors</div>
                    <div className="login_text_2">Management Software</div>

                    <div style={{ height: "30px" }}></div>


                    <TextField
                        id="username"
                        onChange={(e) => setEmail(e.target.value)}
                        variant="filled"
                        className='form-textfield'
                        value={email}
                        label="Username"
                        onKeyUp={handleKeypress}

                    />

                    <div style={{ height: "10px" }}></div>

                    <TextField
                        id="password"
                        type="password"
                        className='form-textfield'
                        onChange={(e) => setPassword(e.target.value)}
                        variant="filled"
                        value={password}
                        label="Password"
                        onKeyUp={handleKeypress}
                    />

                    <div style={{ height: "30px" }}></div>
                    <div>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={processLogin}
                            disabled={disableLoginBtn}
                            sx={{ 
                                width: 200, 
                                height: 50,
                                "&.Mui-disabled": {
                                    background: "#ffffff4d"
                                }
                            }}
                        >
                            LOGIN
                        </Button>
                    </div>

                    <div style={{ height: "10px" }}></div>
                    <div><a href="/reset_password">Forgot Password</a></div>
                    <div style={{ height: "50px" }}></div>
                    <div><img className='footer_img ' src={Footer_text} alt='Footer_text'></img></div>

                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />
                </div>

            </LoadingOverlay>
        </div>
    )
}

export default Login